const defaultLocale = "en";

const availableLocales = [
  "en",
  "es",
  "ru",
  "fr",
  "pt",
  "zh_cn",
  "zh_tw",
  "de",
  "it",
  "ar",
  "pl",
  "ja",
  "tr",
  "uk",
  "ko",
  "hi",
  "he",
  "vi",
];

const loaders = {
  en: () => import(/* webpackChunkName: "lang-en" */ "./en.json"),
  es: () => import(/* webpackChunkName: "lang-es" */ "./es.json"),
  ru: () => import(/* webpackChunkName: "lang-ru" */ "./ru.json"),
  fr: () => import(/* webpackChunkName: "lang-fr" */ "./fr.json"),
  pt: () => import(/* webpackChunkName: "lang-pt" */ "./pt.json"),
  zh_cn: () => import(/* webpackChunkName: "lang-zh-cn" */ "./zh-CN.json"),
  zh_tw: () => import(/* webpackChunkName: "lang-zh-tw" */ "./zh-TW.json"),
  de: () => import(/* webpackChunkName: "lang-de" */ "./de.json"),
  it: () => import(/* webpackChunkName: "lang-it" */ "./it.json"),
  ar: () => import(/* webpackChunkName: "lang-ar" */ "./ar.json"),
  pl: () => import(/* webpackChunkName: "lang-pl" */ "./pl.json"),
  ja: () => import(/* webpackChunkName: "lang-ja" */ "./ja.json"),
  tr: () => import(/* webpackChunkName: "lang-tr" */ "./tr.json"),
  uk: () => import(/* webpackChunkName: "lang-uk" */ "./uk.json"),
  ko: () => import(/* webpackChunkName: "lang-ko" */ "./ko.json"),
  hi: () => import(/* webpackChunkName: "lang-hi" */ "./hi.json"),
  he: () => import(/* webpackChunkName: "lang-he" */ "./he.json"),
  vi: () => import(/* webpackChunkName: "lang-vi" */ "./vi.json"),
};

const loadedLocales = new Set();

function resolveLocale(locale, loaderMap = loaders) {
  return loaderMap[locale] ? locale : defaultLocale;
}

function setI18nLocale(i18n, locale) {
  if (!i18n) return;
  if (typeof i18n.setLocaleMessage === "function" || "locale" in i18n) {
    i18n.locale = locale;
    return;
  }
  if (i18n.global) {
    const current = i18n.global.locale;
    if (current && typeof current === "object" && "value" in current) {
      current.value = locale;
    } else {
      i18n.global.locale = locale;
    }
  }
}

function setI18nMessage(i18n, locale, messages) {
  if (typeof i18n.setLocaleMessage === "function") {
    i18n.setLocaleMessage(locale, messages);
    return;
  }
  if (i18n.global && typeof i18n.global.setLocaleMessage === "function") {
    i18n.global.setLocaleMessage(locale, messages);
  }
}

async function loadLocaleMessages(i18n, locale, loaderMap = loaders) {
  const code = resolveLocale(locale, loaderMap);
  if (!loadedLocales.has(code)) {
    const mod = await loaderMap[code]();
    const messages = mod && mod.default ? mod.default : mod;
    setI18nMessage(i18n, code, messages);
    loadedLocales.add(code);
  }
  setI18nLocale(i18n, code);
  return code;
}

function resetLoadedLocalesForTests(seed = []) {
  loadedLocales.clear();
  for (const locale of seed) loadedLocales.add(locale);
}

const languages = {};

module.exports = {
  defaultLocale,
  availableLocales,
  languages,
  loaders,
  loadLocaleMessages,
  resetLoadedLocalesForTests,
};
